module.exports = __webpack_public_path__ + "static/media/10C.669c20fc.svg";